<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item"></div>
        </div>
        <div class="form_bar_btn">
          <el-button type="primary" @click="editQuestionGroup(null)">
            新增分组
          </el-button>
        </div>
      </div>
      <el-table :data="questionGroupList" style="width: 100%">
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="60"
        ></el-table-column>
        <el-table-column label="题目分类">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="questionManager(scope.row.Id)"
            >
              {{ scope.row.Name }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="其它活动是否共享"
          width="150"
          align="center"
          key="IsPublic"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.IsPublic">是</span>
            <span v-if="!scope.row.IsPublic">否</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" width="50" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="questionManager(scope.row.Id)"
            >
              进入
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editQuestionGroup(scope.row.Id)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteQuestionGroup(scope.row)"
            >
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
      <EditQuestionGroup
        :meetId="meetingId"
        :companyId="companyId"
        :fatherSubmitDialog="editQuestionGroupDialog"
        ref="editQuestionGroup"
      ></EditQuestionGroup>
    </div>
  </div>
</template>
<script>
import questionGroupApi from '../../../../api/wj/questionGroup.js'
import EditQuestionGroup from '@/components/wj_question/EditQuestionGroup.vue'
export default {
  name: 'questionBankManage',
  components: {
    EditQuestionGroup
  },
  data () {
    return {
      meetingId: null,
      companyId: null,
      questionGroupList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        meetingId: null,
        companyId: null,
        maxResultCount: 10,
        skipCount: 0
      },
      pagination_layout: 'prev, pager, next'
    }
  },
  methods: {
    getQuestionGroups: function () {
      const openLoading = this.openLoading()
      questionGroupApi.getQuestionGroups(this.listQuery).then(data => {
        this.questionGroupList = data.Items
        this.listTotalCount = data.TotalCount
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getQuestionGroups()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getQuestionGroups()
    },
    deleteQuestionGroup: function (item) {
      this.$confirm('确认删除题目分类“' + item.Name + '”吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        questionGroupApi.deleteQuestionGroup({
          questionGroupId: item.Id
        }).then(data => {
          openLoading.close()
          this.getQuestionGroups()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editQuestionGroup: function (questionGroupId) {
      this.$refs.editQuestionGroup.openEditQuestionGroup(questionGroupId)
    },
    editQuestionGroupDialog: function () {
      this.getQuestionGroups()
    },
    questionManager: function (questionGroupId) {
      this.$router.push({ name: 'questionManage', params: { cid: this.$route.params.cid, mid: this.$route.params.mid, gid: questionGroupId } })
    }
  },
  computed: {

  },
  created () {
    this.companyId = this.$route.params.cid
    this.meetingId = this.$route.params.mid
    this.listQuery.companyID = this.$route.params.cid
    this.listQuery.meetingId = this.$route.params.mid
    this.getQuestionGroups()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
</style>
